<script>
export default {
  name: "MIcon",
  props:{
    icon: String,
    outlined: {type: Boolean, default: true},
    rounded: {type: Boolean, default: false},
    classImportant: {type: String}
  }
}
</script>

<template>
  <span :class="[
      outlined?'material-icons-outlined':'',
      rounded?'material-icons-round':'',
      ]" class="material-icons horus-icon">{{ icon }}</span>
</template>

<style scoped>

</style>